export const HEADER_OPEN_MENU_STYLE = {
    fontSize: 10,
    background: "#fafafa",
    backgroundSelectedoption: "#256BDE",
    boxShadow: "#256BDE"
};
export const HEADER_MENU_STYLE = {
    paddingRight: 4,
    fillStyleMenu: "#F5F6F8",
    radiusBullets: 1.17,
    spaceBullets: 1.17,
    fillStyleBullets: "#000000"
};
export const SELECTED_HEADER_MENU_STYLE = {
    paddingRight: 4,
    fillStyleMenu: "#699EF2",
    radiusBullets: 1.17,
    spaceBullets: 1.17,
    fillStyleBullets: "#FFFFFF"
};

export const HEADER_MENU_OPTIONS = [
    { id: "export", value: "Export selected class" },
    { id: "import", value: "Import selected class" }
];

export const HEADER_EDIT_BUTTON = {
    editWidth: 47,
    fillStyle: "#ffffff",
    textAlign: "center",
    textValue: "Edit"

};
